/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, ContentChildren } from '@angular/core';
import { ListItemComponent } from './list-item.component';

@Component({
  standalone: false,
  selector: 'gh-list-item-container',
  templateUrl: 'list-item-container.component.html',
  styleUrls: ['list-item-container.component.scss'],
})

export class ListItemContainerComponent {
  @ContentChildren(ListItemComponent) children: ListItemComponent[];

  get isEmpty(): boolean {
    return this.children.length === 0;
  }
}
